import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Formats the response from the Get Filter Options endpoint
 * @function formatFilterOptionsResponse
 *
 * @memberof module:api/facilities/dto
 */
const formatFilterOptionsResponse = (data) => {
    // normalize cities in the format of {label: `${city}, ${state}`, value: `${city}, ${state}`}
    const normalizedCities = data?.cities?.map((city) => ({
        label: `${city.city}, ${city.state}`,
        value: `${city.city}, ${city.state}`,
    }));

    const normalizedStatus = data?.status?.map((status) => ({
        label: status,
        value: status,
    }));

    return {
        cities: normalizedCities,
        status: normalizedStatus,
    };
};

/**
 * This function is used to get facility filter options
 *
 * @function getFilterOptions
 * @returns {Promise<Object>} The formatted response from the mockOperatorAPIService.
 * @throws {Error}
 *
 * @see '/api/v1/facilities/operator-facility-search/filter-options/'
 */
export const getFilterOptions = async () => {
    try {
        const response = await spotheroGet(
            '/facilities/operator-facility-search/filter-options/'
        );

        const formattedResponse = formatFilterOptionsResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        // console.error({error});
        sendSentryException(error);

        throw Error(error);
    }
};

export default getFilterOptions;
